import "./sharedcomponents.css";
import { ArrowRightIcon } from "@heroicons/react/16/solid";
import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useContactModalStore } from "../../stores/contactModalStore";

export const ButtonGreen = ({
    title,
    path = "",
    openModal = false,
}: {
    title: string;
    path?: string;
    openModal?: boolean;
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();
    const { showContactModal, hideContactModal, isShownContactModal } =
        useContactModalStore();
    return (
        <div
            className="flex cursor-pointer overflow-hidden"
            id="button-container"
            onMouseEnter={(e) => {
                setIsHovered(true);
            }}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => {
                if (openModal && !isShownContactModal) {
                    showContactModal();
                    return;
                }
                if (openModal && isShownContactModal) {
                    hideContactModal();
                    return;
                }
                if (path && path.length > 2) {
                    navigate(path);
                    return;
                }
            }}
        >
            <button
                id="main-button"
                className="py-[6px] px-[16px] rounded-[54px] cursor-pointer h-[34px] flex items-center relative text-black-pro bg-green-pro"
                style={{
                    width:
                        window.innerWidth >= 768
                            ? title.length * 8 + 30
                            : title.length * 7 + 50,
                }}
            >
                <motion.p
                    id="fonts-abs"
                    className="font-helvetica-regular"
                    initial={{ opacity: 1, y: 0 }}
                    animate={{
                        y: isHovered ? -28 : 0,
                    }}
                    transition={{
                        duration: 0.15,
                    }}
                >
                    {title}
                </motion.p>

                <motion.p
                    id="bold"
                    className="font-helvetica-bold"
                    initial={{ opacity: 1, y: 28 }}
                    animate={{
                        y: isHovered ? 0 : 28,
                    }}
                    transition={{
                        duration: 0.15,
                    }}
                >
                    {title}
                </motion.p>
            </button>
            <div
                id="icon-container"
                className="flex items-center justify-center w-[34px] h-[34px] rounded-[50%] ml-[-5px] bg-green-pro"
            >
                <span
                    id="icon"
                    className="flex items-center text-black-pro justify-center w-[16px] h-[16px]"
                >
                    <ArrowRightIcon
                        className="text-black-pro"
                        fontSize={16}
                        id="ArrowRightIcon"
                    />
                </span>
            </div>
        </div>
    );
};
